import { usePermanentLocations, usePermanentRealtimeDealers } from "components/DealersAndLocationsDropdown/hooks";
import { usePermanentRealTimeUser } from "hooks";
import { createFormHelper } from "lib/Form";
import { ROLES } from "models";

import type { DealerLocation, User } from "models";

type GroupedLocations = {
  id: number;
  name: string;
  locations: DealerLocation[];
};

type LocationCheckboxesProps = {
  selectedLocations: number[];
  handleSelectLocation: (id: number) => void;
};

const FormHelper = createFormHelper<User>();

export const LocationCheckboxes = ({ handleSelectLocation, selectedLocations }: LocationCheckboxesProps) => {
  const { user } = usePermanentRealTimeUser();
  const { dealers } = usePermanentRealtimeDealers();
  const { locations } = usePermanentLocations();

  const getUserLocations = () => {
    if (!user) return [];

    if ([ROLES.CallCenter].includes(user.role_id)) return locations.filter(location => location.active);
    return locations.filter(location => user.location_ids?.includes(location.id)).filter(loc => loc.active);
  };

  if (!user || ![ROLES.CallCenter, ROLES.WarrantyManager].includes(user.role_id)) return null;

  const dealerIdNameMap: { [id: number]: string } = dealers.reduce((acc, dealer) => ({ ...acc, [dealer.id]: dealer.name }), {});

  const groupedUserLocations = getUserLocations()
    .reduce<GroupedLocations[]>((acc, location) => {
      const dealerExist = acc.find(dealer => dealer.id === location.dealer_id);

      if (dealerExist) dealerExist.locations.push(location);
      else acc.push({ id: location.dealer_id, name: dealerIdNameMap[location.dealer_id] || "", locations: [location] });

      return acc;
    }, [])
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="grouped-locations-container">
      {groupedUserLocations.map(loc => (
        <div key={loc.id} className="grouped-location-container ">
          <span className="bold-text"> {loc.name} </span>

          <div className="selected-locations-container">
            {loc.locations.map(location => (
              <div key={location.id}>
                <FormHelper.Field.Checkbox
                  name="my_locations"
                  onChange={() => handleSelectLocation(location.id)}
                  checkboxProps={{ checked: selectedLocations.some(item => item === location.id) }}
                  label={location.name}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
